exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".top[data-v-2dcb6c61]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.top .according-small[data-v-2dcb6c61]{cursor:pointer}.top .pre[data-v-2dcb6c61]{margin-right:40px}.bottom[data-v-2dcb6c61]{padding-bottom:20px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;margin-top:100px}.bottom .el-button[data-v-2dcb6c61]{width:80px;height:32px;line-height:1px}.el-button[data-v-2dcb6c61]{height:35px;line-height:1px;border-radius:2px}", ""]);

// exports
